export default {"src":"/_next/static/media/error-icon.e31ea437.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};